<div id="feedback__Modal" class="feedback__modal" style="display: flex;">
    <!-- Modal content -->
    <div class="modal-content">
        <div class="feedback__modal--warnig--msg" style="text-align: center;">
            <img src="assets/images/sad.png" alt="" width="80" style="margin: auto;">
            <p class="feedback__Modal--username">Hey {{user?.firstName}}!</p>
            <p class="feedback__Modal--coursename">You didn't meet the attendance threshold required
                to mark this Masterclass as complete.
            </p>
            <p class="feedback__Modal--coursename">Don't worry, a recording of the complete session
                will be available here shortly. Watch it at your convenience to complete the Masterclass module.</p>
            <button (click)="closeModal()">
                OKAY, GOT IT
            </button>
        </div>
    </div>
</div>